<template>
<div>
    <div v-if="isMobile" style="width:100%;height:100%;background:#151515">
     <el-row style="width:100%;">
       <el-col style="height:50px;line-height:50px;text-align:left" :span="11" :offset="1">
          <el-date-picker
        v-model="value1"
      type="datetimerange"
      range-separator="至"
      start-placeholder="开始日期"
      size="small"
      value-format="yyyy-MM-dd HH:mm:ss"
      :default-time="['00:00:00','23:59:59']"
      end-placeholder="结束日期">
    </el-date-picker>
      <el-button icon="el-icon-search" size="small" type="warning" @click="search()">查询</el-button>
     </el-col>
    <el-col style="height:50px;line-height:50px;text-align:right" :span="11">
      <el-button icon="el-icon-s-data" type="warning" @click="dialogTableVisible=true">监控点选择({{dplist.length}})</el-button>
    </el-col>
      
     </el-row>
    <el-row style="width:100%;height:calc(100% - 50px);overflow:auto">
      <el-col  v-loading="loading"  element-loading-background="rgba(0, 0, 0, 0.8)"  :span='12' style="height:410px; border:0.2px #545454 solid" v-for="dp in dplist" :key="dp.innerid">
        <div :id="dp.innerid" style="width:100%;height:410px">
        </div>
      
      </el-col>
       
    </el-row>
        <el-dialog v-if="qlg" style="overflow:auto" title="数据选择" width="250px" :visible.sync="dialogTableVisible">
      <el-row style="padding-top:5px;overflow:auto;height:450px" >
        <el-col v-for="item in alldp" :key="item.innerid" :span="15" :offset="1" style="text-align:left"><el-checkbox v-model="item.checked">{{item.desc}}</el-checkbox></el-col>
      </el-row>
      <el-row style="margin-top:20px">
        <el-button icon="el-icon-check" size="small" type="warning" @click="save()">确定</el-button>
      </el-row>
</el-dialog>
  </div>
  <div v-else style="width:100%;height:100%;background:#151515">
         <el-row style="width:100%;">
       <el-col style="height:50px;line-height:50px;text-align:left" :span="11" :offset="1">
          <el-date-picker
        v-model="value1"
      type="datetimerange"
      range-separator="至"
      start-placeholder="开始日期"
      size="small"
      value-format="yyyy-MM-dd HH:mm:ss"
      :default-time="['00:00:00','23:59:59']"
      end-placeholder="结束日期">
    </el-date-picker>
      <el-button icon="el-icon-search" size="small" type="warning" @click="search()">查询</el-button>
     </el-col>
    <el-col style="height:50px;line-height:50px;text-align:right" :span="11" :offset="12">
      <el-button icon="el-icon-s-data" type="warning" @click="dialogTableVisible=true">监控点选择({{dplist.length}})</el-button>
    </el-col>
      
     </el-row>
    <el-row style="width:100%;height:calc(100% - 50px);overflow:auto">
      <el-col  v-loading="loading"  element-loading-background="rgba(0, 0, 0, 0.8)"  :span='22' :offset="1" style="height:410px; border:0.2px #545454 solid" v-for="dp in dplist" :key="dp.innerid">
        <div :id="dp.innerid" style="width:100%;height:410px">
        </div>
      
      </el-col>
       
    </el-row>
        <el-dialog v-if="qlg" style="overflow:auto" title="数据选择" width="250px" :visible.sync="dialogTableVisible">
      <el-row style="padding-top:5px;overflow:auto;height:450px" >
        <el-col v-for="item in alldp" :key="item.innerid" :span="15" :offset="1" style="text-align:left"><el-checkbox v-model="item.checked">{{item.desc}}</el-checkbox></el-col>
      </el-row>
      <el-row style="margin-top:20px">
        <el-button icon="el-icon-check" size="small" type="warning" @click="save()">确定</el-button>
      </el-row>
</el-dialog>
  </div>
</div>
</template>

<script>
import Vue from "vue";

export default {
  name: "Report",
  props: ['isMobile'],
  data() {
    return {
      project: {},
      value1:[],
      alldp:[],
      dplist:[],
      echarts:{},
      reportdata:null,
      devicelist:[],
      dialogTableVisible:false,
      loading:false,
    };
  },
  watch: {
    isMobile: function (val) {       
        console.log(val);   // 接收父组件的值
    }
  },
  computed:{
     qlg:function(){
      let dev = this.devicelist.filter((d) => {
        return d.protocolid == 150;
      });
      if (dev && dev.length > 0) {
        return dev[0];
      } else {
        return {};
      }
    },
     heatpump:function(){
      let dev = this.devicelist.filter((d) => {
        return d.type == 'heatpump';
      });
      if (dev && dev.length > 0) {
        return dev[0];
      } else {
        return {};
      }
    }
  },
  mounted: function () {
     let project = window.localStorage.getItem('project')
    if (project) {
      this.project = JSON.parse(project)
      if(this.project.innerid != this.project.projectid) {
        this.project.innerid = this.project.projectid
      }
    } else {
      this.$router.push({ name: 'Login' })
    }
    let yesterday=new Date();
    yesterday.setDate(yesterday.getDate()-1);
    this.value1=[yesterday.Format('yyyy-MM-dd HH:mm:00'),(new Date()).Format('yyyy-MM-dd HH:mm:00')];
    var self = this;
    
     Vue.axios
        .post("/api/cchv/device/list", {projectid: this.project.innerid})
        .then((res) => {
          if (res.data.errcode == 0) {
            self.devicelist=res.data.msgbody;
            self.alldp=self.qlg.innerid?self.qlg.dplist.filter(d=>{return d.type==2&&d.dplevel<8}):[]
            self.alldp=self.alldp.concat(self.heatpump.dplist.filter(d=>{return d.type==2&&d.dplevel<8}))
            self.alldp.unshift({innerid:'outhumi',name:'outhumi',desc:'室外湿度'});
            self.alldp.unshift({innerid:'outtemp',name:'outtemp',desc:'室外温度'});

              Vue.axios
        .post("/api/cchv/report/query", { startdate: this.value1[0],enddate:this.value1[1],deviceid:this.qlg.innerid})
        .then((res) => {
          if (res.data.errcode == 0) {
            self.reportdata=res.data.msgbody;
          }
        });

          }
        });
  
  },
  methods: {
    search:function(){
      if(this.value1&&this.value1.length==2){
        var self = this;
         this.loading=true;
      Vue.axios
        .post("/api/cchv/report/query", { startdate: this.value1[0],enddate:this.value1[1],deviceid:this.qlg.innerid })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.reportdata=res.data.msgbody;
            self.save()
          }
        });
      }else{
        this.$message({
          message: '请输入查询时间范围',
          type: 'warning'
        });
      }
    },
    save:function(){
      this.loading=true;
      this.dplist=this.alldp.filter(d=>{return d.checked})
      this.dialogTableVisible=false;
      var self=this;
      setTimeout(function(){
        self.dplist.forEach(dp=>{
         self.echarts[dp.name] = self.$echarts.init(document.getElementById(dp.innerid), 'shine');
         self.echarts[dp.name].setOption(buildOption(self.reportdata,dp.name,dp.desc),true);
         if(dp.name!='powerused'){
            self.echarts[dp.name].group="group1";
         }
         self.echarts[dp.name].resize();
         self.loading=false;
      })
        self.$echarts.connect('group1');
      },1000)
    

     
    }
  },
};

  function buildOption(data,key,reporttitle) {
            var series = []
             series = [{
                    name: reporttitle,
                    type: 'line',
                    data: key=='powerused'?data.acb.y:data[key],
                    smooth: false,
                    showSymbol: true
                }]
            return {
                title: {
                    show: true,
                    text:reporttitle,
                    textStyle:{
                      color:'#ffffff'
                    }
                    
                },
                color: ['#EF5327'],
                grid: {
                    left: '7%',
                    top: '15%',
                    right: '7%',
                    bottom: '10%'
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    show: false,
                    data: ['PM2.5'],
                    right: 0
                },
                xAxis: {
                    type: 'category',
                    axisLine: { show: true, lineStyle: { color: '#545454' } },
                    axisLabel:{
                      color:'#929292'
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                             type: 'dotted',
                             color: '#545454'
                        }

                    },
                    splitNumber:10,
                    boundaryGap: false,
                    data:key=='powerused'?data.acb.x:data.x
                },
                yAxis: {
                    type: 'value',
                    //  splitNumber: 10,
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#545454'
                        }
                    },
                    axisLine: { show: true, lineStyle: { color: '#545454' } },
                    axisLabel: {
                        formatter: '{value}',
                         color:'#929292'
                    },
                    axisTick: { length: 0 }
                },
                series: series

            }
        }

Date.prototype.Format = function (formatStr) {
  var str = formatStr;
  var Week = ["日", "一", "二", "三", "四", "五", "六"];

  str = str.replace(/yyyy|YYYY/, this.getFullYear());
  str = str.replace(
    /yy|YY/,
    this.getYear() % 100 > 9
      ? (this.getYear() % 100).toString()
      : "0" + (this.getYear() % 100)
  );

  str = str.replace(
    /MM/,
    this.getMonth() > 8 ? this.getMonth() + 1 : "0" + (this.getMonth() + 1)
  );
  str = str.replace(/M/g, this.getMonth());

  str = str.replace(/w|W/g, Week[this.getDay()]);

  str = str.replace(
    /dd|DD/,
    this.getDate() > 9 ? this.getDate().toString() : "0" + this.getDate()
  );
  str = str.replace(/d|D/g, this.getDate());

  str = str.replace(
    /hh|HH/,
    this.getHours() > 9 ? this.getHours().toString() : "0" + this.getHours()
  );
  str = str.replace(/h|H/g, this.getHours());
  str = str.replace(
    /mm/,
    this.getMinutes() > 9
      ? this.getMinutes().toString()
      : "0" + this.getMinutes()
  );
  str = str.replace(/m/g, this.getMinutes());

  str = str.replace(
    /ss|SS/,
    this.getSeconds() > 9
      ? this.getSeconds().toString()
      : "0" + this.getSeconds()
  );
  str = str.replace(/s|S/g, this.getSeconds());

  return str;
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Report/CCHReport.vue